/* eslint-disable prefer-destructuring */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-case-declarations */
import React, {
  useState,
  useMemo,
  createContext,
  useEffect,
  useRef,
} from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Manager } from 'socket.io-client'
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
import { v4 as uuid } from 'uuid'
import ExcelJS from 'exceljs'
import { useScreenshot } from 'use-react-screenshot'
import moment from 'moment'
import { usePDF } from 'react-to-pdf'
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   usePDF,
//   Font,
// } from '@react-pdf/renderer'
// import { moduleData } from '../data/moduleData'
import apiServices from '../services/apiServices'
import {
  usePestelStore,
  useCompetitiveStore,
  useCustomerJourneyStore,
  usePersonaStore,
  useInovationStore,
  useDesignStore,
} from '../store'
// import { makeData } from '../lib/utility'
// import { NotoSansTC } from '../fonts/index'

// disable word hyphenation
// Font.registerHyphenationCallback((word) => [word])

// Register font
// Font.register({
//   family: 'Noto Sans TC',
//   src: NotoSansTC,
// })

// Create pdf styles
// const styles = StyleSheet.create({
//   page: {
//     // flexDirection: 'row',
//     backgroundColor: '#E4E4E4',
//     fontFamily: 'Noto Sans TC',
//   },
//   section: {
//     margin: 10,
//     padding: 10,
//     flexGrow: 1,
//     // flexDirection: 'row',
//   },
//   block: {
//     maxWidth: '33%',
//     flexGrow: 1,
//     flexDirection: 'row',
//   },
//   text: {
//     // flexWrap: 'wrap',
//     // flexGrow: 1,
//     flexDirection: 'row',
//     flex: 1,
//     display: 'flex',
//     flexWrap: 'wrap',
//     flexGrow: 1,
//     flexBasis: 0,
//     padding: 2,
//   },
// })

// // Create Document Component
// function PestelDocument({ setting }) {
//   const {
//     data = {
//       pestel: {
//         politic: {
//           pestel_info: [
//             {
//               pestel_sub: 'test',
//               content: 'testcontent',
//             },
//           ],
//         },
//       },
//     },
//   } = setting
//   console.log(data)
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         {Object.keys(data.pestel).map((key) => (
//           <View key={key} style={styles.section}>
//             <Text>{key}</Text>
//             <View key={key} style={styles.block}>
//               {data.pestel[key].pestel_info.map(({ pestel_sub, content }) => (
//                 <View key={pestel_sub}>
//                   <Text>{pestel_sub}</Text>
//                   <Text style={styles.text}>{content}</Text>
//                 </View>
//               ))}
//             </View>
//           </View>
//         ))}
//         {/* <View style={styles.section}>
//           <Text>Section #1</Text>
//         </View>
//         <View style={styles.section}>
//           <Text>Section #2</Text>
//         </View> */}
//       </Page>
//     </Document>
//   )
// }

function ContextProvider(props) {
  const { children } = props
  const [currentID, setCurrentID] = useState(1)
  const [editItems] = useState([
    {
      id: uuid(),
      type: 'text',
      name: '文字',
      icon: 'text.svg',
    },
    {
      id: uuid(),
      type: 'card',
      name: '卡片',
      icon: 'card.svg',
    },
    {
      id: uuid(),
      type: 'media',
      name: '多媒體',
      icon: 'media.svg',
    },
    // {
    //   id: uuid(),
    //   type: 'table',
    //   name: '模板',
    //   icon: 'table.svg',
    // },
  ])

  const location = useLocation()
  const [auth, setAuth] = useState({
    authed: false,
  })
  const logout = () => {
    setAuth({
      authed: false,
    })
    document.cookie = `token=; Domain=${window.location.hostname}; Path=/;`
    window.location.replace('/')
  }
  const authValue = useMemo(() => ({ auth, setAuth, logout }), [auth])
  const checkToken = async () => {
    const { user } = await apiServices.me()
    if (user) {
      setAuth({
        authed: true,
        ...JSON.parse(user),
      })
    }
  }
  useEffect(() => {
    checkToken()
  }, [])
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const info = params.get('info')
    if (info) {
      document.cookie = `token=${params.get('info')}; Domain=${
        window.location.hostname
      }; Path=/;`
      window.location.replace('/', false)
    }
    checkToken()
  }, [location])
  // const { authed, user_id } = auth

  const [componentType, setComponentType] = useState('table')
  const [editDetail] = useState({
    table: [],
    text: [
      {
        id: uuid(),
        name: '區塊標題',
        type: 'title',
        img: 'title.png',
        content: '區塊標題',
      },
      {
        id: uuid(),
        name: '文字',
        type: 'text',
        img: 'text.png',
        content: [
          '<strong>政策支持</strong><p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
        ],
      },
    ],
    card: [
      {
        id: uuid(),
        name: '卡片一',
        img: 'card-1.png',
        type: 'card',
        content: [
          [
            '政策支持',
            '<p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
          ],
        ],
      },
      {
        id: uuid(),
        name: '卡片二',
        img: 'card-2.png',
        type: 'card',
        content: [
          [
            '政策支持',
            '<p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
          ],
          [
            '政策支持',
            '<p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
          ],
        ],
      },
      {
        id: uuid(),
        name: '卡片三',
        img: 'card-3.png',
        type: 'card',
        content: [
          [
            '政策支持',
            '<p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
          ],
          [
            '政策支持',
            '<p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
          ],
          [
            '政策支持',
            '<p>政府是否提供吉他產業相關的補助或稅收優惠？2.政府是否積極推動音樂教育，以提升吉他市場需求？3.政府是否鼓勵本土吉他製造業的發展，以提高產業競爭力？</p>',
          ],
        ],
      },
    ],
    media: [],
  })

  const [list, setList] = useState([])
  const getDrafts = async () => {
    const res = await apiServices.data({
      path: '/draft',
      method: 'get',
    })
    setList(
      res.map((r) => ({
        // title: '電動自行車專案',
        // note: '瀏覽所有生成好的：PESTEL、競品分析、顧客旅程、人物誌。#電動自行車 #台灣 #上班族',
        // status: 'AI設計策略',
        // update_date: '2023-12-02 12:27',
        // img: 'project01.jpg',
        // is_enable: true,
        ...r,
        ...r.setting,
      }))
    )
  }
  useEffect(() => {
    if (auth.authed) getDrafts()
  }, [auth.authed])

  const [draftId, setDraftId] = useState('')
  const [cardList, setCardList] = useState({})

  const [suggestCardList, setSuggestCardList] = useState([])

  // 側邊欄元件展開
  const [sidebar, setSidebar] = useState(false)
  const openSidebar = () => {
    setSidebar(true)
  }

  const closeSidebar = () => {
    setSidebar(false)
  }

  const draft = useMemo(() => {
    if (list && draftId) {
      const target = list.find(({ draft_id }) => draft_id === draftId)
      return {
        ...target,
        ...target.setting,
      }
    }
    return {}
  }, [list, draftId])

  const { authed, user_id } = auth
  const [socket, setSocket] = useState(null)
  useEffect(() => {
    if (!authed) return () => {}
    const manager = new Manager(window.location.origin)
    const newSocket = manager.socket('/', {
      auth: {
        auth: user_id,
      },
    })
    setSocket(newSocket)
    return () => newSocket.close()
  }, [setSocket, authed, user_id])
  const sendMessage = (type, message) => socket.emit(type, message)
  const socketValue = useMemo(() => ({ socket, sendMessage }), [socket])

  // 警告視窗
  const [showWarn, setShowWarn] = useState({ show: false, text: '' })

  // 重新生成視窗
  const [showGen, setShowGen] = useState({ show: false, text: '' })

  const handleDraftAdd = async (q, s) => {
    const res = await apiServices.data({
      path: '/draft',
      method: 'post',
      data:
        s === 1
          ? {
              q,
            }
          : {
              q2: q,
            },
    })
    setList([
      {
        ...res,
        ...res.setting,
      },
      ...list,
    ])
    return res
  }

  const handleDraftDelete = async (id) => {
    const res = await apiServices.data({
      path: `/draft/${id}`,
      method: 'delete',
    })
    setList(list.filter((l) => l.draft_id !== id))
    return res
  }

  // full data and history
  const pestelStore = usePestelStore((store) => ({
    politic: store.politic,
    economic: store.economic,
    social: store.social,
    technology: store.technology,
    environment: store.environment,
    law: store.law,
    setField: store.setField,
    updateFullPestel: store.updateFullPestel,
    init: store.init,
  }))

  const competitiveStore = useCompetitiveStore((state) => ({
    competitive: state.competitive,
    setField: state.setField,
    init: state.init,
  }))

  const customerJourneyStore = useCustomerJourneyStore((store) => ({
    user_info: store.user_info,
    emotions: store.emotions,
    journeys: store.journeys,
    opportunities_and_painpoints: store.opportunities_and_painpoints,
    setField: store.setField,
    init: store.init,
  }))

  const personaStore = usePersonaStore((store) => ({
    user_info: store.user_info,
    quote: store.quote,
    health_advocate_profile: store.health_advocate_profile,
    setField: store.setField,
    init: store.init,
  }))

  const inovationStore = useInovationStore((store) => ({
    product_innovation: store.product_innovation,
    service_innovation: store.service_innovation,
    business_model: store.business_model,
    infra_develop: store.infra_develop,
    tab_list: store.tab_list,
    setField: store.setField,
    init: store.init,
  }))

  const designStore = useDesignStore((store) => ({
    opportunities_and_challenges: store.opportunities_and_challenges,
    setField: store.setField,
    init: store.init,
  }))

  // undo and redo
  const [history, setHistory] = useState([])
  const [recoverTarget, setRecoverTarget] = useState(-1)
  const [cursor, setCursor] = useState(-1)
  const handleRecover = (target) => setRecoverTarget(target)

  const [touched, settouched] = useState(false)
  useEffect(() => {
    settouched(false)
    setCursor(-1)
    setRecoverTarget(-1)
  }, [currentID, draftId])

  // useEffect(() => {
  //   if (recoverTarget !== -1) {
  //     pestelStore.updateFullPestel(history[recoverTarget])
  //     setCursor(recoverTarget)
  //     setRecoverTarget(-1)
  //   }
  // }, [recoverTarget])

  // useEffect(() => {
  //   const data = makeData(
  //     pestelStore,
  //     competitiveStore,
  //     customerJourneyStore,
  //     personaStore,
  //     inovationStore,
  //     designStore
  //   )
  //   console.log(data)
  // }, [
  //   pestelStore.economic,
  //   pestelStore.environment,
  //   pestelStore.law,
  //   pestelStore.politic,
  //   pestelStore.social,
  //   pestelStore.technology,
  //   competitiveStore,
  //   customerJourneyStore,
  //   personaStore,
  //   inovationStore,
  //   designStore,
  // ])

  const [initing, setiniting] = useState(false)
  const [inited, setinited] = useState([])

  const initMultipleDataFromJson = async (json_urls, setField, q) => {
    setiniting(true)
    setinited(
      Array.from(new Set([...inited, ...json_urls.map(({ url }) => url)]))
    )
    try {
      const dataArray = []
      console.log('starting job')
      await json_urls.reduce(async (prev, { url, target, dataName }) => {
        if (prev) await prev
        const response = await fetch(
          `${window.location.protocol}/api/draft/${draftId}/${url.replace(
            '.json',
            ''
          )}`,
          {
            method: 'post',
            body: JSON.stringify({
              q,
            }),
            headers: {
              'content-type': 'application/json',
            },
          }
        )
        if (!response.ok) {
          throw new Error(`Network response was not ok for ${url}`)
        }
        const contentType = response.headers.get('content-type')
        if (!contentType || !contentType.includes('application/json')) {
          throw new TypeError(`Received non-JSON response from ${url}`)
        }
        const json = await response.json()
        dataArray.push(json)
        console.log('inside job')
        if (target) {
          setField(dataName, json[target])
        } else {
          setField(dataName, json)
        }
        return json
      }, [])

      // dataArray.forEach((data, index) => {
      //   const fieldName = json_urls[index].dataName
      //   if (json_urls[index].target) {
      //     setField(fieldName, data[json_urls[index].target])
      //   } else {
      //     setField(fieldName, data)
      //   }
      // })
    } catch (error) {
      console.error('Failed to fetch data:', error)
    }
    console.log('end job')
    setiniting(false)
  }

  const bgArr = ['#F9FBFF', '#E0F7FA', '#FFF3E0'] // 示例背景颜色数组
  // const fetchCompetitiveParital = () => {
  //   fetch(
  //     '/data/competitive_product_analysis/competitive_partial_generation.json'
  //   )
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw new Error('Network response was not ok')
  //       }
  //       return res.json()
  //     })
  //     .then((data) => {
  //       const newData = {
  //         ...data,
  //         id: uuid(),
  //         bg: bgArr[Math.floor(Math.random() * bgArr.length)],
  //       }
  //       return newData
  //     })
  //     .catch((error) => {
  //       console.error('Fetch error:', error)
  //       return null
  //     })
  // }

  // const addItem = async (labelID, competitive, setField) => {
  //   const index = competitive.findIndex((item) => item.id === labelID)

  //   const newData = JSON.parse(JSON.stringify(competitive))
  //   const fetchedData = await fetchCompetitiveParital()

  //   if (fetchedData) {
  //     newData.splice(index + 1, 0, fetchedData)
  //     setField('competitive', newData)
  //   }
  // }

  // const deleteCard = (labelID, competitive, setField) => {
  //   let newData = JSON.parse(JSON.stringify(competitive))
  //   newData = newData.filter((item) => item.id !== labelID)
  //   setField('competitive', newData)
  // }

  // const textEdit = (id, value, label, competitive, setField) => {
  //   let newData = JSON.parse(JSON.stringify(competitive))
  //   newData = newData.map((item) =>
  //     item.id === id ? { ...item, [label]: value } : item
  //   )
  //   setField('competitive', newData)
  // }

  // const arrayEdit = (label, value, type, i, competitive, setField) => {
  //   const newData = competitive.map((item) => {
  //     if (item.id !== label) return item

  //     const updatedItem = { ...item }
  //     if (type === 'weaknesses') {
  //       updatedItem.weaknesses = item.weaknesses.map((row, index) =>
  //         index === i ? value : row
  //       )
  //     } else {
  //       updatedItem.strengths = item.strengths.map((row, index) =>
  //         index === i ? value : row
  //       )
  //     }

  //     return updatedItem
  //   })

  //   setField('competitive', newData)
  // }

  const initCompetitive = (setField, q) => {
    setiniting(true)
    setinited(
      Array.from(
        new Set([...inited, 'competitive_product_analysis/competitive'])
      )
    )
    fetch(
      `${window.location.protocol}/api/draft/${draftId}/data/competitive_product_analysis/competitive`,
      {
        method: 'post',
        body: JSON.stringify({
          q,
        }),
        headers: {
          'content-type': 'application/json',
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (!data.competitive) return
        // const priceType = data['2-1_competitive'].shift()
        const newData = data.competitive.map((innerItem, index) => ({
          ...innerItem,
          id: uuid(),
          bg: bgArr[index % bgArr.length],
        }))
        // setField('price_symbol', priceType.price_symbol)
        setField('competitive', newData)
      })
    setiniting(false)
  }

  const initAll = () => {
    pestelStore.init()
    competitiveStore.init()
    designStore.init()
    inovationStore.init()
    customerJourneyStore.init()
    personaStore.init()
  }
  useEffect(() => {
    if (!draftId) initAll()
  }, [draftId])

  const regen = async (q = '', pathname = '', urls = false) => {
    let setField = () => {}
    let init = () => {}
    let json_urls = []
    switch (pathname) {
      case '/module1':
        setField = pestelStore.setField
        init = pestelStore.init
        json_urls = urls || [
          {
            url: 'data/pestel/politic.json',
            dataName: 'politic',
          },
          {
            url: 'data/pestel/economic.json',
            dataName: 'economic',
          },
          {
            url: 'data/pestel/social.json',
            dataName: 'social',
          },
          {
            url: 'data/pestel/technology.json',
            dataName: 'technology',
          },
          {
            url: 'data/pestel/environment.json',
            dataName: 'environment',
          },
          {
            url: 'data/pestel/law.json',
            dataName: 'law',
          },
        ]
        init()
        initMultipleDataFromJson(json_urls, setField, q)
        break
      case '/module2/product':
        setField = competitiveStore.setField
        init = competitiveStore.init
        init()
        initCompetitive(setField, q)
        break
      case '/module2/matrix':
        setField = competitiveStore.setField
        init = competitiveStore.init
        init()
        initCompetitive(setField, q)
        break
      case '/module2/design':
        setField = designStore.setField
        init = designStore.init
        init()
        initCompetitive(setField, q)
        break
      case '/module2/inovation':
        setField = inovationStore.setField
        init = inovationStore.init
        init()
        initCompetitive(setField, q)
        break
      case '/module3':
        setField = customerJourneyStore.setField
        init = customerJourneyStore.init
        json_urls = urls || [
          {
            url: 'data/customer_journey/user_info.json',
            dataName: 'user_info',
          },
          {
            url: 'data/customer_journey/journeys.json',
            dataName: 'journeys',
          },
          {
            url: 'data/customer_journey/emotions.json',
            dataName: 'emotions',
          },
          {
            url: 'data/customer_journey/opportunities_and_painpoints.json',
            dataName: 'opportunities_and_painpoints',
          },
        ]
        init()
        if (personaStore.user_info.isLoading) personaStore.init()
        initMultipleDataFromJson(json_urls, setField, q)
        break
      case '/module4':
        setField = personaStore.setField
        init = personaStore.init
        json_urls = urls || [
          {
            url: 'data/persona/user_info.json',
            dataName: 'user_info',
          },
          {
            url: 'data/persona/quote.json',
            dataName: 'quote',
          },
          {
            url: 'data/persona/health_advocate_profile.json',
            dataName: 'health_advocate_profile',
          },
        ]
        init()
        if (customerJourneyStore.user_info.isLoading)
          customerJourneyStore.init()
        initMultipleDataFromJson(json_urls, setField, q)
        break
      default:
        break
    }
  }

  const makeData = () => ({
    competitive_product_analysis: {
      business_model: { 'business-model': inovationStore.business_model },
      competitive: {
        competitive: competitiveStore.competitive,
      },
      'opportunities-and-challenges': {
        'opportunities-and-challenges':
          designStore.opportunities_and_challenges,
      },
      infra_develop: { 'infra-develop': inovationStore.infra_develop },
      product_innovation: {
        'product-innovation': inovationStore.product_innovation,
      },
      service_innovation: {
        'service-innovation': inovationStore.service_innovation,
      },
    },
    customer_journey: {
      emotions: customerJourneyStore.emotions,
      journeys: customerJourneyStore.journeys,
      opportunities_and_painpoints:
        customerJourneyStore.opportunities_and_painpoints,
      user_info: customerJourneyStore.user_info,
    },
    persona: {
      health_advocate_profile: personaStore.health_advocate_profile,
      quote: personaStore.quote,
      user_info: personaStore.user_info,
    },
    pestel: {
      economic: pestelStore.economic,
      environment: pestelStore.environment,
      law: pestelStore.law,
      politic: pestelStore.politic,
      social: pestelStore.social,
      technology: pestelStore.technology,
    },
  })

  const toExcel = async (all = false, id = 0) => {
    const data = await apiServices.data({
      path: `draft/${id || draftId}`,
      method: 'get',
    })
    console.log(data)
    const workbook = new ExcelJS.Workbook()
    // const customer_journey = workbook.addWorksheet('customer_journey')
    // const persona = workbook.addWorksheet('persona')

    // module 1
    if (currentID === 1 || all) {
      const pestel = workbook.addWorksheet('pestel')
      Object.keys(data.pestel).forEach((key, i) => {
        pestel.mergeCells(
          `${String.fromCharCode(65)}${i * 5}`,
          `${String.fromCharCode(65 + Object.keys(data.pestel[key]).length)}${
            i * 5 + 1
          }`
        )
        pestel.getCell(`${String.fromCharCode(65)}${i * 5 + 1}`).value =
          data.pestel[key].pestel
        pestel.getCell(`${String.fromCharCode(65)}${i * 5 + 1}`).alignment = {
          vertical: 'middle',
          horizontal: 'center',
          wrapText: true,
        }
        data.pestel[key].pestel_info.forEach(({ pestel_sub, content }, j) => {
          pestel.getCell(`${String.fromCharCode(65 + j)}${i * 5 + 2}`).value =
            pestel_sub
          pestel.getCell(
            `${String.fromCharCode(65 + j)}${i * 5 + 2}`
          ).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          pestel.getColumn(j + 1).width = 50
          pestel.getCell(`${String.fromCharCode(65 + j)}${i * 5 + 3}`).value =
            content
          pestel.getCell(
            `${String.fromCharCode(65 + j)}${i * 5 + 3}`
          ).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          pestel.getRow(`${i * 5 + 3}`).height = 90
        })
      })
    }

    // module 2
    if (currentID === 2 || all) {
      const cpa = workbook.addWorksheet('competitive_product_analysis')
      // data.business_model['business-model']
      cpa.getCell(`${String.fromCharCode(65)}1`).value = '品牌名稱'
      cpa.getCell(`${String.fromCharCode(66)}1`).value = '優勢'
      cpa.getCell(`${String.fromCharCode(67)}1`).value = '劣勢'
      cpa.getCell(`${String.fromCharCode(68)}1`).value = '價格區間'
      cpa.getCell(`${String.fromCharCode(69)}1`).value = '產品特點'
      cpa.getCell(`${String.fromCharCode(70)}1`).value = '主要客群'

      data.competitive_product_analysis.competitive.competitive.forEach(
        (c, i) => {
          cpa.mergeCells(
            `${String.fromCharCode(65)}${i * 3 + 2}`,
            `${String.fromCharCode(65)}${i * 3 + 4}`
          )
          cpa.mergeCells(
            `${String.fromCharCode(68)}${i * 3 + 2}`,
            `${String.fromCharCode(68)}${i * 3 + 4}`
          )
          cpa.mergeCells(
            `${String.fromCharCode(69)}${i * 3 + 2}`,
            `${String.fromCharCode(69)}${i * 3 + 4}`
          )
          cpa.mergeCells(
            `${String.fromCharCode(70)}${i * 3 + 2}`,
            `${String.fromCharCode(70)}${i * 3 + 4}`
          )
          cpa.getCell(`${String.fromCharCode(65)}${i * 3 + 2}`).value =
            c.brand_name

          cpa.getColumn(1).width = 50
          cpa.getColumn(2).width = 50
          cpa.getColumn(3).width = 50
          cpa.getColumn(4).width = 50
          cpa.getColumn(5).width = 50
          cpa.getColumn(6).width = 50
          cpa.getColumn(1).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cpa.getColumn(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cpa.getColumn(3).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cpa.getColumn(4).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cpa.getColumn(5).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cpa.getColumn(6).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cpa.getCell(`${String.fromCharCode(66)}${i * 3 + 2}`).value =
            c.strengths[0]
          cpa.getCell(`${String.fromCharCode(66)}${i * 3 + 3}`).value =
            c.strengths[1]
          cpa.getCell(`${String.fromCharCode(66)}${i * 3 + 4}`).value =
            c.strengths[2]
          cpa.getCell(`${String.fromCharCode(67)}${i * 3 + 2}`).value =
            c.weaknesses[0]
          cpa.getCell(`${String.fromCharCode(67)}${i * 3 + 3}`).value =
            c.weaknesses[1]
          cpa.getCell(`${String.fromCharCode(67)}${i * 3 + 4}`).value =
            c.weaknesses[2]
          cpa.getCell(
            `${String.fromCharCode(68)}${i * 3 + 2}`
          ).value = `${c.price_banding_min}~${c.price_banding_max}`
          cpa.getCell(`${String.fromCharCode(69)}${i * 3 + 2}`).value =
            c.features
          cpa.getCell(`${String.fromCharCode(70)}${i * 3 + 2}`).value =
            c.audiences
        }
      )

      const design = workbook.addWorksheet('design')
      const ds =
        data.competitive_product_analysis['opportunities-and-challenges'][
          'opportunities-and-challenges'
        ]
      design.getRow(3).height = 100
      design.getRow(7).height = 100
      ds.forEach((d, i) => {
        design.getColumn(i + 1).width = 40
        design.getColumn(i + 1).alignment = {
          vertical: 'middle',
          horizontal: 'center',
          wrapText: true,
        }
        design.getCell(`${String.fromCharCode(65 + i)}1`).value = '設計機會'
        design.getCell(`${String.fromCharCode(65 + i)}5`).value = '設計挑戰'
        design.getCell(`${String.fromCharCode(65 + i)}2`).value =
          d.opportunities_headline
        design.getCell(`${String.fromCharCode(65 + i)}3`).value =
          d.opportunities
        design.getCell(`${String.fromCharCode(65 + i)}6`).value =
          d.challenges_headline
        design.getCell(`${String.fromCharCode(65 + i)}7`).value = d.challenges
      })
      design.getCell(`${String.fromCharCode(67)}1`).value = '設計機會'
      design.getCell(`${String.fromCharCode(65)}5`).value = '設計挑戰 '
      design.getCell(`${String.fromCharCode(66)}5`).value = '設計挑戰 '
      design.getCell(`${String.fromCharCode(77)}5`).value = '設計挑戰 '

      const inovation = workbook.addWorksheet('inovation')
      const is = {
        business_model:
          data.competitive_product_analysis.business_model['business-model'],
        infra_develop:
          data.competitive_product_analysis.infra_develop['infra-develop'],
        product_innovation:
          data.competitive_product_analysis.product_innovation[
            'product-innovation'
          ],
        service_innovation:
          data.competitive_product_analysis.service_innovation[
            'service-innovation'
          ],
      }

      inovation.getCell(`${String.fromCharCode(65)}1`).value = '產品創新'
      inovation.getCell(`${String.fromCharCode(65)}8`).value = '服務創新'
      inovation.getCell(`${String.fromCharCode(65)}15`).value = '商業模式'
      inovation.getCell(`${String.fromCharCode(65)}22`).value = '環境建設'
      const keys = [
        'product_innovation',
        'service_innovation',
        'business_model',
        'infra_develop',
      ]
      const images = await Promise.all(
        keys
          .reduce(
            (prev, key) => [
              ...prev,
              ...is[key].reduce((prevk, iss) => [...prevk, ...iss.images], []),
            ],
            []
          )
          .map(async (src) => {
            const res = await apiServices.data({
              path: src[0].replace('/api/', ''),
              method: 'get',
              responseType: 'arraybuffer',
            })
            const base64String = btoa(
              [].reduce.call(
                new Uint8Array(res),
                (p, c) => p + String.fromCharCode(c),
                ''
              )
            )
            // const blob = new Blob([res])
            // const dataUrl = URL.createObjectURL(blob)
            // console.log(dataUrl)
            const image = workbook.addImage({
              base64: base64String,
              extension: 'png',
            })
            return image
          })
      )
      console.log(images)
      keys.forEach((key, index) => {
        inovation.getRow(index * 7 + 5).height = 100
        inovation.getRow(index * 7 + 6).height = 100
        inovation.getRow(index * 7 + 5).alignment = {
          vertical: 'middle',
          wrapText: true,
        }
        is[key].forEach((iss, i) => {
          inovation.mergeCells(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 2}`,
            `${String.fromCharCode(66 + i * 2)}${index * 7 + 2}`
          )
          inovation.mergeCells(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 3}`,
            `${String.fromCharCode(66 + i * 2)}${index * 7 + 3}`
          )
          inovation.mergeCells(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 4}`,
            `${String.fromCharCode(66 + i * 2)}${index * 7 + 4}`
          )
          inovation.mergeCells(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 5}`,
            `${String.fromCharCode(66 + i * 2)}${index * 7 + 5}`
          )

          inovation.getColumn(i * 2 + 1).width = 40
          inovation.getColumn(i * 2 + 2).width = 40
          inovation.getCell(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 2}`
          ).value = `方案${i + 1}`
          inovation.getCell(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 3}`
          ).value = `推薦度：${iss.star}`
          inovation.getCell(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 4}`
          ).value = iss.headline

          inovation.getCell(
            `${String.fromCharCode(65 + i * 2)}${index * 7 + 5}`
          ).value = iss.ideas
          inovation.addImage(images[i * 2 + index * 6], {
            tl: { col: i * 2, row: index * 7 + 5 },
            ext: { width: 128, height: 128 },
          })
          inovation.addImage(images[i * 2 + 1 + index * 6], {
            tl: { col: i * 2 + 1, row: index * 7 + 5 },
            ext: { width: 128, height: 128 },
          })
        })
      })
    }

    // module 3
    if (currentID === 3 || all) {
      const cj = workbook.addWorksheet('custom_journey')
      const is = data.customer_journey
      const res = await apiServices.data({
        path: is.user_info.image[0].replace('/api/', ''),
        method: 'get',
        responseType: 'arraybuffer',
      })
      const base64String = btoa(
        [].reduce.call(
          new Uint8Array(res),
          (p, c) => p + String.fromCharCode(c),
          ''
        )
      )
      const image = workbook.addImage({
        base64: base64String,
        extension: 'png',
      })
      cj.addImage(image, {
        tl: { col: 0, row: 0 },
        ext: { width: 256, height: 256 },
      })
      cj.mergeCells(
        `${String.fromCharCode(65)}1`,
        `${String.fromCharCode(66)}5`
      )
      cj.mergeCells(
        `${String.fromCharCode(69)}2`,
        `${String.fromCharCode(69)}5`
      )
      cj.getColumn(1).width = 30
      cj.getColumn(2).width = 30
      cj.getColumn(3).width = 30
      cj.getColumn(4).width = 30
      cj.getColumn(5).width = 30
      cj.getRow(1).height = 50
      cj.getRow(2).height = 50
      cj.getRow(3).height = 50
      cj.getRow(4).height = 50
      cj.getRow(5).height = 50

      cj.getCell(`${String.fromCharCode(67)}1`).value = '姓名'
      cj.getCell(`${String.fromCharCode(68)}1`).value = is.user_info.name
      cj.getCell(`${String.fromCharCode(67)}2`).value = '年齡'
      cj.getCell(`${String.fromCharCode(68)}2`).value = is.user_info.age
      cj.getCell(`${String.fromCharCode(67)}3`).value = '性別'
      cj.getCell(`${String.fromCharCode(68)}3`).value =
        is.user_info.male_or_female
      cj.getCell(`${String.fromCharCode(67)}4`).value = '職業'
      cj.getCell(`${String.fromCharCode(68)}4`).value = is.user_info.occupation

      cj.getCell(`${String.fromCharCode(67)}5`).value = '任務'
      cj.getCell(`${String.fromCharCode(68)}5`).value = is.user_info.task
      cj.getCell(`${String.fromCharCode(68)}5`).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      }
      cj.getCell(`${String.fromCharCode(69)}1`).value = '人物基本介紹'
      cj.getCell(`${String.fromCharCode(69)}2`).value =
        is.user_info.user_scenario
      cj.getCell(`${String.fromCharCode(69)}2`).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      }

      cj.getCell(`${String.fromCharCode(65)}7`).value = '接觸點'
      cj.mergeCells(
        `${String.fromCharCode(65)}7`,
        `${String.fromCharCode(69)}7`
      )
      cj.getRow(11).height = 100
      is.journeys.events.forEach((event, i) => {
        cj.getCell(`${String.fromCharCode(65 + i)}8`).value = event.touchpoint
        cj.mergeCells(
          `${String.fromCharCode(65 + i)}9`,
          `${String.fromCharCode(65 + i)}11`
        )
        cj.getCell(
          `${String.fromCharCode(65 + i)}9`
        ).value = `${event.action[0]}\n${event.action[0]}\n${event.channels_and_stakeholders}`
        cj.getCell(`${String.fromCharCode(65 + i)}9`).alignment = {
          vertical: 'middle',
          horizontal: 'center',
          wrapText: true,
        }
      })

      cj.getCell(`${String.fromCharCode(65)}13`).value = '痛點與機會點'
      cj.mergeCells(
        `${String.fromCharCode(65)}13`,
        `${String.fromCharCode(69)}13`
      )
      cj.getRow(14).height = 100
      cj.getRow(15).height = 100
      is.opportunities_and_painpoints.opportunities_and_painpoints.forEach(
        (oap, i) => {
          cj.getCell(`${String.fromCharCode(65 + i)}14`).value = oap.painpoint
          cj.getCell(`${String.fromCharCode(65 + i)}15`).value = oap.opportunity
          cj.getCell(`${String.fromCharCode(65 + i)}14`).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cj.getCell(`${String.fromCharCode(65 + i)}15`).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
        }
      )
    }

    // module4
    if (currentID === 4 || all) {
      const ps = workbook.addWorksheet('persona')
      const is = data.persona
      console.log(is)
      const images = await Promise.all(
        is.user_info.gallery.map(async (src) => {
          const res = await apiServices.data({
            path: src[0].replace('/api/', ''),
            method: 'get',
            responseType: 'arraybuffer',
          })
          const base64String = btoa(
            [].reduce.call(
              new Uint8Array(res),
              (p, c) => p + String.fromCharCode(c),
              ''
            )
          )
          // const blob = new Blob([res])
          // const dataUrl = URL.createObjectURL(blob)
          // console.log(dataUrl)
          const image = workbook.addImage({
            base64: base64String,
            extension: 'png',
          })
          return image
        })
      )
      console.log(images)

      ps.getColumn(1).width = 30
      ps.getColumn(2).width = 30
      ps.getColumn(3).width = 30
      ps.getColumn(4).width = 30
      ps.getColumn(5).width = 30
      ps.getColumn(6).width = 30
      ps.getColumn(7).width = 30
      ps.getColumn(8).width = 30
      ps.getRow(1).height = 100
      ps.getRow(2).height = 100
      ps.getRow(3).height = 100
      ps.getRow(4).height = 100
      ps.getRow(5).height = 30
      ps.getRow(6).height = 30
      ps.getRow(7).height = 30
      ps.getRow(8).height = 30
      ps.getRow(9).height = 30
      ps.getRow(11).height = 30
      ps.getRow(12).height = 30
      ps.getRow(13).height = 30
      ps.getRow(14).height = 30
      ps.getRow(15).height = 30
      ps.getRow(16).height = 30
      ps.getRow(17).height = 30
      ps.getRow(18).height = 30

      images.forEach((image, i) => {
        ps.addImage(image, {
          tl: { col: (i % 2) * 2, row: parseInt(i / 2, 10) * 2 },
          ext: { width: 256, height: 256 },
        })
        console.log((i / 2) * 2 + 1)
        console.log((i / 2) * 2 + 2)
        ps.mergeCells(
          `${String.fromCharCode(65 + (i % 2) * 2)}${
            parseInt(i / 2, 10) * 2 + 1
          }`,
          `${String.fromCharCode(66 + (i % 2) * 2)}${
            parseInt(i / 2, 10) * 2 + 2
          }`
        )
      })

      ps.mergeCells(
        `${String.fromCharCode(66)}5`,
        `${String.fromCharCode(68)}5`
      )
      ps.mergeCells(
        `${String.fromCharCode(66)}6`,
        `${String.fromCharCode(68)}6`
      )
      ps.mergeCells(
        `${String.fromCharCode(66)}7`,
        `${String.fromCharCode(68)}7`
      )
      ps.mergeCells(
        `${String.fromCharCode(66)}8`,
        `${String.fromCharCode(68)}8`
      )
      ps.mergeCells(
        `${String.fromCharCode(66)}9`,
        `${String.fromCharCode(68)}9`
      )
      ps.getCell(`${String.fromCharCode(65)}5`).value = '姓名'
      ps.getCell(`${String.fromCharCode(66)}5`).value = is.user_info.name
      ps.getCell(`${String.fromCharCode(65)}6`).value = '年齡'
      ps.getCell(`${String.fromCharCode(66)}6`).value = is.user_info.age
      ps.getCell(`${String.fromCharCode(65)}7`).value = '職業'
      ps.getCell(`${String.fromCharCode(66)}7`).value = is.user_info.occupation
      ps.getCell(`${String.fromCharCode(65)}8`).value = '家庭狀況'
      ps.getCell(`${String.fromCharCode(66)}8`).value =
        is.user_info.family_status
      ps.getCell(`${String.fromCharCode(65)}9`).value = '常用物件'
      ps.getCell(`${String.fromCharCode(66)}9`).value =
        is.user_info.frequently_used_items.join()

      ps.mergeCells(
        `${String.fromCharCode(69)}1`,
        `${String.fromCharCode(72)}1`
      )
      ps.mergeCells(
        `${String.fromCharCode(69)}2`,
        `${String.fromCharCode(72)}4`
      )
      ps.mergeCells(
        `${String.fromCharCode(69)}5`,
        `${String.fromCharCode(72)}7`
      )
      ps.mergeCells(
        `${String.fromCharCode(69)}8`,
        `${String.fromCharCode(72)}9`
      )
      ps.getCell(`${String.fromCharCode(69)}1`).value = '動機與行為'
      ps.getCell(`${String.fromCharCode(69)}2`).value =
        is.user_info.motivations_and_behaviors
      ps.getCell(`${String.fromCharCode(69)}2`).alignment = {
        vertical: 'middle',
        wrapText: true,
      }
      ps.getCell(`${String.fromCharCode(69)}5`).value =
        is.quote.quote.join('\n')
      ps.getCell(`${String.fromCharCode(69)}5`).alignment = {
        vertical: 'middle',
        wrapText: true,
      }
      ps.getCell(`${String.fromCharCode(69)}8`).value =
        is.health_advocate_profile.characteristics_and_focus.join()
      ps.getCell(`${String.fromCharCode(69)}8`).alignment = {
        vertical: 'middle',
        wrapText: true,
      }

      ps.mergeCells(
        `${String.fromCharCode(65)}11`,
        `${String.fromCharCode(68)}11`
      )
      ps.mergeCells(
        `${String.fromCharCode(65)}12`,
        `${String.fromCharCode(68)}14`
      )
      ps.getCell(`${String.fromCharCode(65)}11`).value = '目標'
      ps.getCell(`${String.fromCharCode(65)}12`).value =
        is.health_advocate_profile.user_end_goal.join('\n')

      ps.mergeCells(
        `${String.fromCharCode(69)}11`,
        `${String.fromCharCode(72)}11`
      )
      ps.mergeCells(
        `${String.fromCharCode(69)}12`,
        `${String.fromCharCode(72)}14`
      )
      ps.getCell(`${String.fromCharCode(69)}11`).value = '偏好'
      ps.getCell(`${String.fromCharCode(69)}12`).value =
        is.health_advocate_profile.lifestyle_preferences.join('\n')

      ps.mergeCells(
        `${String.fromCharCode(65)}15`,
        `${String.fromCharCode(68)}15`
      )
      ps.mergeCells(
        `${String.fromCharCode(65)}16`,
        `${String.fromCharCode(68)}18`
      )
      ps.getCell(`${String.fromCharCode(65)}15`).value = '痛點'
      ps.getCell(`${String.fromCharCode(65)}16`).value =
        is.health_advocate_profile.painpoints.join('\n')

      ps.mergeCells(
        `${String.fromCharCode(69)}15`,
        `${String.fromCharCode(72)}15`
      )
      ps.mergeCells(
        `${String.fromCharCode(69)}16`,
        `${String.fromCharCode(72)}18`
      )
      ps.getCell(`${String.fromCharCode(69)}15`).value = '需求'
      ps.getCell(`${String.fromCharCode(69)}16`).value =
        is.health_advocate_profile.needs.join('\n')
    }
    console.log('-----------start downloading-------------')
    const file = await workbook.xlsx.writeBuffer({
      base64: true,
    })
    const excel = new Blob([file], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = URL.createObjectURL(excel)
    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('download', `匯出.xlsx`)
    document.body.appendChild(link)

    // const downloadFunc = () => {
    link.click()
    link.remove()
    // }
    console.log('-----------end downloading-------------')
  }

  // const [instance, updateInstance] = usePDF({
  //   document: <PestelDocument setting={{}} />,
  // })
  // const [pdfing, setpdfing] = useState(false)
  // useEffect(() => {
  //   console.log(instance)
  //   if (instance.loading || instance.error) return
  //   if (pdfing) {
  //     const link = document.createElement('a')
  //     link.setAttribute('href', instance.url)
  //     link.setAttribute('download', `匯出.pdf`)
  //     document.body.appendChild(link)
  //     setpdfing(false)
  //     // const downloadFunc = () => {
  //     link.click()
  //     link.remove()
  //   }
  // }, [instance])
  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' })

  // const toPDF = () => {
  // const data = makeData()
  // console.log(data)
  // console.log(updateInstance)
  // const newDocument = <PestelDocument setting={{ data }} />
  // console.log(newDocument)
  // updateInstance(newDocument)
  // setpdfing(true)
  // }

  const [saves, setsaves] = useState([])
  const getSaves = async () => {
    const res = await apiServices.data({
      path: `/draft/${draftId}/version`,
      method: 'get',
    })
    setsaves(res)
  }

  const editSave = async (id, data) => {
    const res = await apiServices.data({
      path: `/draft/${draftId}/version/${id}`,
      method: 'put',
      data,
    })
    setsaves(saves.map((s) => (s.version_id === id ? res : s)))
  }

  const recoverSave = async (id) => {
    const res = await apiServices.data({
      path: `/draft/${draftId}/version/${id}`,
      method: 'get',
    })
    console.log(res)
    let setField = () => {}
    let keys = []
    switch (location.pathname) {
      case '/module1':
        setField = pestelStore.setField
        keys = [
          'politic',
          'economic',
          'social',
          'technology',
          'environment',
          'law',
        ]
        keys.forEach((key) => setField(key, res.pestel[key]))
        break
      case '/module2/product':
        setField = competitiveStore.setField
        setField(
          'competitive',
          res.competitive_product_analysis.competitive.competitive
        )
        break
      case '/module2/matrix':
        setField = competitiveStore.setField
        setField('competitive', res.competitive_product_analysis.competitive)
        break
      case '/module2/design':
        setField = designStore.setField
        setField(
          'opportunities_and_challenges',
          res.competitive_product_analysis['opportunities-and-challenges'][
            'opportunities-and-challenges'
          ]
        )
        break
      case '/module2/inovation':
        setField = inovationStore.setField
        keys = [
          'product_innovation',
          'service_innovation',
          'business_model',
          'infra_develop',
        ]
        keys.forEach((key) =>
          setField(
            key,
            res.competitive_product_analysis[key][key.replace('_', '-')]
          )
        )
        break
      case '/module3':
        setField = customerJourneyStore.setField
        keys = [
          'user_info',
          'journeys',
          'emotions',
          'opportunities_and_painpoints',
        ]
        keys.forEach((key) => setField(key, res.customer_journey[key]))
        break
      case '/module4':
        setField = personaStore.setField
        keys = ['user_info', 'quote', 'health_advocate_profile']
        keys.forEach((key) => setField(key, res.persona[key]))
        break
      default:
        break
    }
  }

  const copySave = async (id) => {
    const res = await apiServices.data({
      path: `/draft/${draftId}/version/${id}/copy`,
      method: 'post',
    })
    setsaves([res, ...saves])
  }

  const saveDraft = async () => {
    await apiServices.data({
      path: `/draft/${draftId}/version`,
      method: 'post',
      data: {
        inited: inited.map((i) => i.replace('data/', '').replace('.json', '')),
        ...makeData(),
      },
    })
    getSaves()
    getDrafts()
    setHistory([])
  }

  const screenshotRef = useRef(null)
  const [image, takeScreenshot] = useScreenshot()
  const uploadImg = async (file) => {
    // const getArrayBuffer = () =>
    //   new Promise((resolve) => {
    //     const reader = new FileReader()
    //     reader.addEventListener('load', () => {
    //       resolve(reader.result)
    //     })
    //     reader.readAsArrayBuffer(file)
    //   })
    // files.push(getArrayBuffer())

    // const files = []
    const byteCharacters = atob(file.replace('data:image/png;base64,', ''))
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const arrayed = [
      {
        name: `thumbnail_${draftId}_${moment().format('yyyyMMDD')}`,
        data: Array.from(byteArray),
      },
    ]

    // const buffered = await Promise.all(files)
    // const arrayed = buffered.map((buffer) => ({
    //   name: `thumbnail_${draftId}_${moment().format('yyyyMMDD')}`,
    //   data: Array.from(new Uint8Array(buffer)),
    // }))
    const res = await apiServices.data({
      path: `draft/image`,
      method: 'post',
      data: {
        files: JSON.stringify(arrayed),
      },
    })
    if (!res.error) {
      await apiServices.data({
        path: `draft/data/${draftId}`,
        method: 'put',
        data: {
          thumbnail: `/api/draft/image/${res[0].name}`,
        },
      })
    }
    saveDraft()
  }
  useEffect(() => {
    if (!image) return
    uploadImg(image)
  }, [image])
  const save = () => takeScreenshot(screenshotRef.current)

  useEffect(() => {
    if (draftId) getSaves()
  }, [draftId])

  const load = async (versionId) => {
    const res = await apiServices.data({
      path: `/draft/${draftId}/version/${versionId}`,
      method: 'get',
    })
    console.log(res)
  }

  useEffect(() => {
    setinited([])
  }, [draftId])

  useEffect(() => {
    setHistory([])
    setCursor(0)
  }, [currentID])

  const handleDraftUpdate = async () => {
    await apiServices.data({
      path: `/draft/${draftId}`,
      method: 'put',
      data: {
        inited: inited.map((i) => i.replace('data/', '').replace('.json', '')),
        ...makeData(),
      },
    })
  }

  const recover = () => {
    let setField = () => {}
    let keys = []
    switch (location.pathname) {
      case '/module1':
        setField = pestelStore.setField
        keys = [
          'politic',
          'economic',
          'social',
          'technology',
          'environment',
          'law',
        ]
        console.log('triggered this')
        keys.forEach((key) => {
          console.log(history)
          console.log(key)
          console.log(history[recoverTarget].pestel[key])
          setField(key, history[recoverTarget].pestel[key])
        })
        break
      case '/module2/product':
        setField = competitiveStore.setField
        setField(
          'competitive',
          history[recoverTarget].competitive_product_analysis.competitive
            .competitive
        )
        break
      case '/module2/matrix':
        setField = competitiveStore.setField
        setField(
          'competitive',
          history[recoverTarget].competitive_product_analysis.competitive
        )
        break
      case '/module2/design':
        setField = designStore.setField
        setField(
          'opportunities_and_challenges',
          history[recoverTarget].competitive_product_analysis[
            'opportunities-and-challenges'
          ]['opportunities-and-challenges']
        )
        break
      case '/module2/inovation':
        setField = inovationStore.setField
        keys = [
          'product_innovation',
          'service_innovation',
          'business_model',
          'infra_develop',
        ]
        keys.forEach((key) =>
          setField(
            key,
            history[recoverTarget].competitive_product_analysis[key][
              key.replace('_', '-')
            ]
          )
        )
        break
      case '/module3':
        setField = customerJourneyStore.setField
        keys = [
          'user_info',
          'journeys',
          'emotions',
          'opportunities_and_painpoints',
        ]
        keys.forEach((key) =>
          setField(key, history[recoverTarget].customer_journey[key])
        )
        break
      case '/module4':
        setField = personaStore.setField
        keys = ['user_info', 'quote', 'health_advocate_profile']
        keys.forEach((key) =>
          setField(key, history[recoverTarget].persona[key])
        )
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (!initing) setHistory([])
  }, [initing])

  useEffect(() => {
    if (recoverTarget !== -1) {
      recover()
      setCursor(recoverTarget)
    }
  }, [recoverTarget])

  // first history
  useEffect(() => {
    if (touched) {
      setHistory([makeData()])
    }
  }, [touched])

  useEffect(() => {
    console.log(recoverTarget)
    if (initing) return
    if (recoverTarget !== -1) {
      setRecoverTarget(-1)
    } else if (touched) {
      console.log('this is triggered and histort is now:', history)
      console.log(`initing ? ${initing}`)
      if (cursor !== -1) {
        setHistory((prevState) => [
          ...prevState.slice(0, cursor + 1),
          makeData(),
        ])
        setCursor(-1)
      } else {
        setHistory((prevState) => [...prevState, makeData()])
      }
    }
    if (!initing) handleDraftUpdate()
  }, [
    pestelStore.economic,
    pestelStore.politic,
    pestelStore.social,
    pestelStore.technology,
    pestelStore.environment,
    pestelStore.law,
    competitiveStore.competitive,
    designStore.opportunities_and_challenges,
    inovationStore.business_model,
    inovationStore.infra_develop,
    inovationStore.product_innovation,
    inovationStore.service_innovation,
    customerJourneyStore.emotions,
    customerJourneyStore.journeys,
    customerJourneyStore.user_info,
    customerJourneyStore.opportunities_and_painpoints,
    personaStore.health_advocate_profile,
    personaStore.quote,
    personaStore.user_info,
    initing,
  ])

  const [listSearch, setlistSearch] = useState('')

  const draftValue = useMemo(
    () => ({
      list,
      setList,
      listSearch,
      setlistSearch,
      currentID,
      setCurrentID,
      editItems,
      editDetail,
      handleDraftAdd,
      handleDraftDelete,
      handleDraftUpdate,
      draft,
      draftId,
      setDraftId,
      history,
      // setHistory,
      recoverTarget,
      setRecoverTarget,
      cursor,
      setCursor,
      handleRecover,
      componentType,
      setComponentType,
      showWarn,
      setShowWarn,
      sidebar,
      openSidebar,
      closeSidebar,
      cardList,
      setCardList,
      suggestCardList,
      setSuggestCardList,
      showGen,
      setShowGen,
      initMultipleDataFromJson,
      initCompetitive,
      regen,
      screenshotRef,
      save,
      saves,
      editSave,
      copySave,
      recoverSave,
      touched,
      settouched,
      load,
      toExcel,
      toPDF,
      targetRef,
      setDraft: (data, selectedId = '') => {
        setList((prevState) =>
          prevState
            ? prevState.map((p) =>
                p.draft_id === (draftId || selectedId)
                  ? {
                      ...p,
                      ...data.module,
                    }
                  : p
              )
            : prevState
        )
      },
    }),
    [
      list,
      listSearch,
      editItems,
      editDetail,
      draftId,
      cursor,
      recoverTarget,
      history,
      cardList,
      componentType,
      sidebar,
      currentID,
      showWarn,
      showGen,
      saves,
      touched,
    ]
  )

  // 警告視窗
  const [toast, setToast] = useState({
    show: false,
    text: '',
    func: () => {},
  })
  const toastValue = useMemo(() => ({ toast, setToast }), [toast])

  // 生成助手
  const [helper, sethelper] = useState({
    show: false,
    history: [],
  })
  const helperValue = useMemo(() => ({ helper, sethelper }), [helper])

  return (
    <>
      <AuthContext.Provider value={authValue}>
        <ToastContext.Provider value={toastValue}>
          <HelperContext.Provider value={helperValue}>
            <DraftContext.Provider value={draftValue}>
              <SocketContext.Provider value={socketValue}>
                {children}
              </SocketContext.Provider>
            </DraftContext.Provider>
          </HelperContext.Provider>
        </ToastContext.Provider>
      </AuthContext.Provider>
      <ToastContainer position="top-center">
        <Toast
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={3000}
          autohide
          style={{ width: '100%' }}
        >
          <Toast.Body>{toast.text}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  )
}

ContextProvider.propTypes = {
  children: PropTypes.shape().isRequired,
}

export const ToastContext = createContext({
  toast: { show: false, text: '' },
  setToast: () => {},
  func: () => {},
})

export const DraftContext = createContext(null)
export const HelperContext = createContext({
  helper: {
    show: false,
    history: [],
  },
  sethelper: () => {},
})

export const SocketContext = createContext({
  socket: null,
  sendMessage: () => {},
})

export default ContextProvider

export const AuthContext = createContext({
  auth: {
    authed: false,
  },
  setAuth: () => {},
})

// PestelDocument.propTypes = {
//   setting: PropTypes.shape().isRequired,
// }
